var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import * as S from './Radio.styled';
export const Radio = (_a) => {
    var { name, value, checked, disabled, readOnly, tabIndex, inputRef, onChange, onBlur } = _a, rest = __rest(_a, ["name", "value", "checked", "disabled", "readOnly", "tabIndex", "inputRef", "onChange", "onBlur"]);
    return (React.createElement(S.Container, null,
        React.createElement(S.Input, Object.assign({ type: "radio", name: name, value: value, ref: inputRef, tabIndex: tabIndex, checked: checked, disabled: disabled, readOnly: readOnly, onChange: onChange, onBlur: onBlur }, rest)),
        React.createElement(S.Radio, null)));
};
//# sourceMappingURL=Radio.js.map